import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';

// context 
import DataProvider from './context/DataProvider/DataProvider';
import { I18nProvider } from './i18n/I18nProvider';

// Homepages 
import BusinessManagement from './pages/home-pages/business-management';


// inner pages 
import Terms from './pages/inner-pages/terms';
import About from './pages/inner-pages/about';
import Services from './pages/inner-pages/services';
import Pricing from './pages/inner-pages/pricing';
import Feature from './pages/inner-pages/features';
import Contact from './pages/inner-pages/contact';
import HelpCenter from './pages/inner-pages/help-center';
import BlogDetails from './pages/inner-pages/blog-details';
import AboutSolution from './pages/inner-pages/about-solution';
import PricingSolution from './pages/inner-pages/pricing-solution';
import ContactSolution from './pages/inner-pages/contact-solution';
import FeaturesSolution from './pages/inner-pages/features-solution';
import HelpCenterDetails from './pages/inner-pages/help-center-details';
import CustomerTestimonial from './pages/inner-pages/customer-testimonial';
import Career from './pages/inner-pages/career';
import CareerDetails from './pages/inner-pages/career-details';
import PostRequest from './pages/inner-pages/post-request';
import ProviderSignup from './pages/inner-pages/provider-signup';
import UserRequest from './pages/inner-pages/user-request';
import ServiceProviders from './pages/inner-pages/service-providers';
import ProviderDetails from './pages/inner-pages/provider-details';
import ServiceCategoryPage from './components/ServiceCategoryPage/ServiceCategoryPage';
import SubServiceDetails from './pages/inner-pages/sub-service-details';
import RequestProjectTitle from './pages/inner-pages/request-project-title';
import RequestDemandDetails from './pages/inner-pages/request-demand-details';
import RequestDemandStep4 from './pages/inner-pages/request-demand-step4';
import RequestDemandStep5 from './pages/inner-pages/request-demand-step5';
import RequestDemandStep6 from './pages/inner-pages/request-demand-step6';
import RequestDemandStep7 from './pages/inner-pages/request-demand-step7';
import RequestDemandStep8 from './pages/inner-pages/request-demand-step8';
import RequestDemandStep9 from './pages/inner-pages/request-demand-step9';
import RequestDemandStep10 from './pages/inner-pages/request-demand-step10';
import RequestDemandStep11 from './pages/inner-pages/request-demand-step11';
import RequestDemandStep12 from './pages/inner-pages/request-demand-step12';
import SupportSav from './pages/inner-pages/support-sav';
import PaymentPage from './pages/inner-pages/payment';
import PaymentReturn from './pages/inner-pages/payment-return';
import ConfirmEmail from './pages/inner-pages/confirm-email';

// miscellaneous pages
import NotFound from './pages/404';
import Login from './pages/auth/login';
import Signup from './pages/auth/sign-up';
import Profile from './pages/auth/profile';
import ProviderSettings from './pages/auth/provider-settings';
import AdminDashboard from './pages/auth/admin-dashboard';
import ResetPassword from './pages/auth/reset-password';
import ForgotPassword from './pages/auth/forgot-password';
import NioScrollToTop from './components/NioScrollToTop/NioScrollToTop';

function RequireAuth({ children }) {
  const location = useLocation();
  const storedUser = localStorage.getItem('user');

  if (!storedUser) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }

  // Jeton JWT expiré ou corrompu => session terminée, retour au login.
  try {
    const parsed = JSON.parse(storedUser);
    const token = parsed?.token;
    if (!token) {
      localStorage.removeItem('user');
      return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
    }
    const payload = JSON.parse(atob(token.split('.')[1] || ''));
    if (!payload?.exp || payload.exp * 1000 <= Date.now()) {
      localStorage.removeItem('user');
      return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
    }
  } catch {
    localStorage.removeItem('user');
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

function AppRoutes() {

  return (
    <Routes>

      <Route path="/" element={<Navigate to="/index-bs-management" replace />} />

      {/* Homepages */}
      <Route path="/index-bs-management" element={<BusinessManagement />} />

      {/* inner page  */}
      <Route path='/about' element={<About />} />
      <Route path='/services' element={<Services />} />
      <Route path='/features' element={<Feature />} />
      <Route path='/pricing' element={<Pricing />} />
      <Route path='/contact-us' element={<Contact />} />
      <Route path='/help-center' element={<HelpCenter />} />
      <Route path='/blog-details' element={<BlogDetails />} />
      <Route path='/terms-and-conditions' element={<Terms />} />
      <Route path='/about-solution' element={<AboutSolution />} />
      <Route path='/features-solution' element={<FeaturesSolution />} />
      <Route path='/pricing-solution' element={<PricingSolution />} />
      <Route path='/contact-us-solution' element={<ContactSolution />} />
      <Route path='/help-center-details' element={<HelpCenterDetails />} />
      <Route path='/customer-testimonials' element={<CustomerTestimonial />} />
      <Route path='/careers' element={<Career />} />
      <Route path='/career-details' element={<CareerDetails />} />
      <Route path='/service/:serviceId/providers' element={<ServiceProviders />} />
      <Route path='/service/:serviceId/sub-service-details' element={<SubServiceDetails />} />
      <Route path='/service/:serviceId/request-project-title' element={<RequireAuth><RequestProjectTitle /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-details' element={<RequireAuth><RequestDemandDetails /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step4' element={<RequireAuth><RequestDemandStep4 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step5' element={<RequireAuth><RequestDemandStep5 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step6' element={<RequireAuth><RequestDemandStep6 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step7' element={<RequireAuth><RequestDemandStep7 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step8' element={<RequireAuth><RequestDemandStep8 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step9' element={<RequireAuth><RequestDemandStep9 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step10' element={<RequireAuth><RequestDemandStep10 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step11' element={<RequireAuth><RequestDemandStep11 /></RequireAuth>} />
      <Route path='/service/:serviceId/request-demand-step12' element={<RequireAuth><RequestDemandStep12 /></RequireAuth>} />
      <Route path='/confirm-email' element={<ConfirmEmail />} />
      <Route path='/services/:slug' element={<ServiceCategoryPage />} />
      <Route path='/providers/:providerId' element={<ProviderDetails />} />
      <Route path='/post-request' element={<PostRequest />} />
      <Route path='/provider-signup/:serviceId?' element={<ProviderSignup />} />
      <Route path='/user-request' element={<UserRequest />} />
      <Route path='/support-sav' element={<RequireAuth><SupportSav /></RequireAuth>} />
      <Route path='/service-apres-vente' element={<RequireAuth><SupportSav /></RequireAuth>} />
      <Route path='/payment' element={<RequireAuth><PaymentPage /></RequireAuth>} />
      <Route path='/payment/return' element={<PaymentReturn />} />

      {/* miscellaneous pages */}
      <Route path="*" element={<NotFound />} />
      <Route path="/404" element={<NotFound />} />
      <Route path='/auth/login' element={<Login />} />
      <Route path='/auth/sign-up' element={<Signup />} />
      <Route path='/profile' element={<Profile />} />
      <Route path='/profile/provider' element={<ProviderSettings />} />
      <Route path='/admin/dashboard' element={<AdminDashboard />} />
      <Route path='/auth/reset-password' element={<ResetPassword />} />
      <Route path='/auth/forgot-password' element={<ForgotPassword />} />

    </Routes>
  );
}


function App() {

  useEffect(() => {
    document.body.classList.add('nk-body');
  }, []);

  return (
    <I18nProvider>
      <DataProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <NioScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </DataProvider>
    </I18nProvider>
  );
}



export default App;
